import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import VimdtAccordion from '../Common/VimdtAccordion';
import ImageRenderItem from './ImageRenderItem';

function ImageRenderList({
	vin,
	imageList,
	rowCount,
	imageType,
	background,
	isDownload,
	innerPanels,
}) {
	const { t } = useTranslation();
	const [panels, setPanels] = useState([]);

	const { extList, intList, bisList } = useMemo(() => {
		if (!imageList) return { extList: [], intList: [], bisList: [] };
		const byTitle = (a, b) => a.title.localeCompare(b.title);
		return {
			extList: imageList.filter((image) => image.title.match('EXT')).sort(byTitle),
			bisList: imageList.filter((image) => image.title.match('BIS')).sort(byTitle),
			intList: imageList
				.filter((image) => image.title.match('INT') || image.title.match('BET'))
				.sort(byTitle),
		};
	}, [imageList]);

	useEffect(() => {
		if (!innerPanels) {
			setPanels([]);
			return;
		}
		const open = [];
		if (extList.length > 0) open.push('ext');
		if (intList.length > 0) open.push('int');
		if (bisList.length > 0) open.push('bis');
		setPanels(open);
	}, [innerPanels, extList, intList, bisList]);

	const renderItem = (list) => (
		<ImageRenderItem
			vin={vin}
			imageList={list}
			imageType={imageType}
			background={background}
			rowCount={rowCount}
			isDownload={isDownload}
		/>
	);

	const items = [
		extList.length > 0 && {
			key: 'ext',
			header: t('vimdt.imagesTab.layouts.ext'),
			content: renderItem(extList),
		},
		intList.length > 0 && {
			key: 'int',
			header: t('vimdt.imagesTab.layouts.int'),
			content: renderItem(intList),
		},
		bisList.length > 0 && {
			key: 'bis',
			header: t('vimdt.imagesTab.layouts.bis'),
			content: renderItem(bisList),
		},
	].filter(Boolean);

	return <VimdtAccordion items={items} activeKeys={panels} onChange={setPanels} />;
}

export default ImageRenderList;
